import type { KeyboardEvent } from 'react';

export const createHotkeyAction = (event: KeyboardEvent) => (action: () => void) => {
  event.preventDefault();
  action();
};
